module.exports = __webpack_public_path__ + "img/icon_yiwancheng.d010aaab.png";